/**
 * 行情首页JS
 */

import ad from "../modules/ad";
import url from "../modules/url";

//首页广告
// let index_ad = new ad('All_pages,Market_center_HSH')
// index_ad.getData().then(function(){
//   // //顶部广告
//   index_ad.render($('#adDTT'), 'DTT').then(function(){
//     document.body.style.paddingTop = document.getElementById("adDTT").clientHeight + "px";
//   })

//   // //底部广告
//   let BottomPosition = url.getQuery('position') == null ? "DT" : url.getQuery('position');
//   index_ad.render($('#bottomAD'), BottomPosition)  

//   // //中部广告
//   index_ad.render($('#middlead'), 'BKZJ')  
// })


  